import React from 'react';
import { IoMdStar, IoMdStarHalf } from 'react-icons/io';

export default function Rating({ rating }) {
  const star = rating;
  return (
    <div className="mt-1 d-flex justify-content-between align-items-center">
      <div className="small-ratings">
        {Array.from(Array(Math.floor(star)), () => {
          return <IoMdStar className={`${'rating-color'}`} key={Math.random()} />;
        })}
        {rating % 1 === 0 ? '' : <IoMdStarHalf className={`${'rating-color'}`} key={Math.random()} />}
      </div>
    </div>
  );
}
